import { styled } from "styled-components";

import { redundantCssFromKebab } from "../../styles/redundant-css";

export const ShadowWrapper = styled.div`
    ${redundantCssFromKebab("padding", "1rem")}
`;
